/*
 * Anything that must match values in CSS
 */

/* Define some breakpoints, they must match those on CSS */
const bootstrapBreakpoints = {
  xs: 0,
  sm:	576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export default {
  bootstrapBreakpoints,
};
